exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%; }\n\n.example-full-width {\n  width: 100%; }\n\n.bg-white {\n  background-color: #ffffff; }\n\n.upload-btn-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  top: 0px; }\n\n.upload-btn-wrapper input[type=file] {\n  font-size: 100px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0; }\n\n.upload-btn-wrapper span {\n  font-size: 14px; }\n\n/deep/ .mat-input-element:disabled {\n  color: #333; }\n\n.profile-pic {\n  width: 200px;\n  height: 150px; }\n\n.img-box {\n  width: 200px;\n  height: auto; }\n\n.img-box img {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/app/my-profile/my-profile.component.scss
// module id = ../../../../../src/app/my-profile/my-profile.component.scss
// module chunks = main